import "../common/common";
import "%modules%/header/header";
import "%modules%/nav/nav";
import "%modules%/form/form";
import "%modules%/slider/slider";
import "%modules%/portfolio/portfolio";
import "%modules%/modal/modal";
import "%modules%/steps/steps";
import "%modules%/cookie/cookie";